/* eslint-disable import/no-anonymous-default-export */
export default {
  a_01a: "Y",
  a_01b: "R",
  a_02a: "R",
  a_02b: "Y",
  a_03: "R",
  a_04: "R",
  a_05: "R",
  a_06: "R",
  a_09: "Y",
  a_10: "G",
  a_11: "R",
  a_12: "G",
  a_13: "R",
  abbr_01: "R",
  akey_01: "R",
  applet_01: "R",
  area_01a: "G",
  area_01b: "R",
  aria_01: "G",
  aria_02: "G",
  aria_03: "G",
  aria_04: "R",
  aria_05: "G",
  aria_06: "R",
  aria_07: "G",
  aria_08: "R",
  audio_video_01: "G",
  audio_video_02: "R",
  autocomplete_01: "G",
  autocomplete_02: "R",
  blink_01: "R",
  blink_02: "R",
  br_01: "R",
  button_01: "G",
  button_02: "R",
  color_01: "Y",
  color_02: "R",
  css_01: "Y",
  css_02: "Y",
  dtd_01: "R",
  ehandler_01: "Y",
  ehandler_02: "R",
  ehandler_03: "G",
  ehandler_04: "R",
  embed_01: "R",
  element_01: "G",
  element_02: "G",
  element_03: "R",
  element_04: "G",
  element_05: "R",
  element_06: "G",
  element_07: "R",
  element_08: "G",
  element_09: "R",
  element_10: "G",
  field_01: "R",
  field_02: "R",
  focus_01: "R",
  font_01: "R",
  font_02: "R",
  form_01a: "G",
  form_01b: "R",
  frame_01: "R",
  frame_02: "R",
  heading_01: "G",
  heading_02: "R",
  heading_03: "G",
  heading_04: "R",
  headers_01: "G",
  headers_02: "R",
  hx_01a: "R",
  hx_01b: "Y",
  hx_01c: "R",
  hx_02: "R",
  hx_03: "R",
  id_01: "G",
  id_02: "R",
  iframe_01: "R",
  iframe_02: "G",
  iframe_03: "R",
  iframe_04: "G",
  iframe_05: "R",
  img_01a: "G",
  img_01b: "R",
  img_02: "Y",
  img_03: "R",
  img_04: "Y",
  inp_img_01a: "G",
  inp_img_01b: "R",
  input_01: "R",
  input_02: "Y",
  input_02b: "G",
  input_03: "R",
  justif_txt_01: "R",
  justif_txt_02: "Y",
  label_01: "G",
  label_02: "R",
  label_03: "R",
  landmark_01: "G",
  landmark_02: "R",
  landmark_03: "G",
  landmark_04: "R",
  landmark_05: "G",
  landmark_06: "R",
  landmark_07: "G",
  landmark_08: "R",
  landmark_09: "G",
  landmark_10: "R",
  landmark_11: "G",
  landmark_12: "R",
  landmark_13: "G",
  landmark_14: "R",
  lang_01: "Y",
  lang_02: "R",
  lang_03: "R",
  lang_04: "R",
  lang_05: "R",
  layout_01a: "G",
  layout_01b: "R",
  layout_02a: "G",
  layout_02b: "R",
  layout_03: "R",
  letter_01: "G",
  letter_02: "R",
  link_01: "G",
  list_01: "R",
  list_02: "G",
  list_03: "R",
  list_04: "G",
  list_05: "R",
  list_06: "G",
  list_07: "R",
  listitem_01: "G",
  listitem_02: "R",
  long_01: "R",
  marquee_01: "Y",
  menuItem_01: "G",
  menuItem_02: "R",
  meta_01: "Y",
  meta_02: "Y",
  meta_03: "G",
  meta_04: "R",
  meta_05: "G",
  object_01: "G",
  object_02: "R",
  orientation_01: "G",
  orientation_02: "R",
  role_01: "G",
  role_02: "R",
  scope_01: "R",
  scrollable_01: "G",
  scrollable_02: "R",
  svg_01: "G",
  svg_02: "R",
  table_01: "Y",
  table_02: "R",
  table_03: "R",
  table_04: "R",
  table_05a: "R",
  table_06: "R",
  table_07: "G",
  table_08: "R",
  textC_01: "Y",
  textC_02: "Y",
  title_01: "R",
  title_02: "R",
  title_03: "R",
  title_04: "Y",
  title_05: "R",
  title_06: "G",
  title_07: "Y",
  values_01a: "Y",
  values_01b: "G",
  values_02a: "Y",
  values_02b: "G",
  video_01: "G",
  video_02: "G",
  w3c_validator_01a: "G",
  w3c_validator_01b: "Y",
  win_01: "Y",
  word_01: "G",
  word_02: "R",
};
